import AsyncBlockService from 'services/async-block-service';
import ef from 'ef/ef';
var Block = require('models/block');
var BlockCollection = require('collections/block_collection');

var utils = require('lib/utils');
var CourseSettingsService = require('services/course-settings-service');
var LoadService = require('services/load-service');
var LocaleService = require('services/locale-service');

var content;

var ContentService = function() {
  if (ContentService.prototype._singleton) {
    return ContentService.prototype._singleton;
  }

  ContentService.prototype._singleton = this;

  this.files = {
    _groups: './content/groups.json',
    _modules: './content/modules.json',
    _moduleContent: './content/module-content.json'
  };

  Object.defineProperty(this, 'groups', { get: function() { return content._groups; } });
  Object.defineProperty(this, 'modules', { get: function() { return content._modules; } });
  Object.defineProperty(this, 'moduleContent', { get: function() { return content._moduleContent; } });

  this.initialize = function(){
    const split = CourseSettingsService.get('split_module');
    if (split) {
      this.files._modules = `./modules/${split}/content/module.json`;
      this.files._moduleContent = `./modules/${split}/content/module-content.json`;
    }
    return LoadService.load(this.files).done(function(data){
      content = data;
    });
  };

  this.applyPageContent = function(page) {
    let m, a, p;
    var linkedPage = page.get('link');
    if(linkedPage) {
      [m, a, p] = [linkedPage.module, linkedPage.activity, linkedPage.page];
    } else {
      [m, a, p] = [page.module.get('key'), page.activity.get('key'), page.get('key')];
    }
    return this.applyContentAndLocale(page, m + '.' + a + '.' + p).then(() => {
      return Promise.resolve(page);
    });
  };

  this.applyContentAndLocale = function(container, path){
    return this.applyContent(container, path).then((containerParam) => {
      LocaleService.addDefaultResources(path);
      return Promise.resolve(containerParam);
    });
  };

  this.applyContent = function(container, path) {
    // Deep clone, so that the original source is not mutated
    //   This was causing some of the translations, to get translated twice and spit out error text
    var content = _.clone(utils.dotStringToObject(path, this.moduleContent), true);
    return this.buildBlockCollection(content && content.blocks).then((blocks) => {
      if(content && content.blocks) {
        content.blocks = blocks;
      }
      container.set(content);
      return Promise.resolve(container);
    });
  };

  this.buildBlockCollection = function(rawBlocks) {
    if(!rawBlocks) { return new Promise( resolve => resolve() ); }

    return AsyncBlockService.load(rawBlocks.map(b => b.type || b.get('type'))).then(() => {
      return Promise.resolve(
        rawBlocks instanceof Backbone.Collection ? rawBlocks : new BlockCollection(rawBlocks.map((block) => {
          if(typeof block === 'string' && this.moduleContent['base-blocks'] !== undefined){
            block = this.moduleContent['base-blocks'][block];
          }
          if(blockAvailable(block)) {
            return new Block(block);
          }
        }).filter(b => b !== undefined))
      );
    });
  };

  var blockAvailable = function(block){
    var available = true;
    if (block.completed_modules_required){
      available = block.completed_modules_required <= ef.modules.completedModuleCount();
    }
    if (available && block.certified !== undefined){
      return block.certified === ef.enrollment.get('certified');
    }

    return available;
  };
};

module.exports = new ContentService();
